<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
                scrollTop: 0
            }
        },
        created() {
            var u = navigator.userAgent;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isIOS) {
                document.body.addEventListener('focusin', () => {  //软键盘弹起事件
                    this.scrollTop = document.scrollingElement.scrollTop;
                });
                document.body.addEventListener('focusout', () => { //软键盘关闭事件
                    document.scrollingElement.scrollTo(0, this.scrollTop)
                })
            }
        }
    }
</script>

<style lang="less">
    html {
        color: #000;
        background: #FFF;
    }

    body,
    div,
    dl,
    dt,
    dd,
    ul,
    ol,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    pre,
    code,
    form,
    fieldset,
    legend,
    input,
    button,
    textarea,
    p,
    blockquote,
    th,
    td,
    strong {
        padding: 0;
        margin: 0;
    }

    html, body {
        -webkit-tap-highlight-color: transparent;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    img {
        border: 0;
    }

    a {
        text-decoration: none;
        color: #000;
        outline: none;
    }

    a:hover {
        text-decoration: none;
    }

    var,
    em,
    strong {
        font-style: normal;
    }

    em,
    strong,
    th,
    var {
        font-style: inherit;
        font-weight: inherit;
    }

    li {
        list-style: none;
    }

    caption,
    th {
        text-align: left;
    }

    h1, h2, h3, h4, h5, h6 {
        font-size: 100%;
        font-weight: normal;
    }

    input, button, textarea, select, optgroup, option {
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        font-weight: inherit;
    }

    input, button, textarea, select {
        *font-size: 100%;
    }

    .clearfix {
        *zoom: 1;
    }

    .clearfix:after {
        content: '\200B';
        clear: both;
        display: block;
        height: 0;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue